import { MockedRequest, ResponseResolver, restContext } from 'msw';
import { TempFileResponse } from '../../api/types/tempFile';

const uploadTempFile: ResponseResolver<
  MockedRequest,
  typeof restContext
> = async (req, res, ctx) => {
  return delayedResponse(
    ctx.status(201),
    ctx.json<TempFileResponse>({
      fileId: 1,
    }),
  );
};

const mockTempFile = {
  uploadTempFile,
};
export default mockTempFile;
